import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTongHopThongKeActionsObj = {
    SELECTED_MENU: "",
}

export const eTongHopThongKeActionIds = generateActionTypeIds(eTongHopThongKeActionsObj, "TONG_HOP_THONG_KE");
export type ITongHopThongKeActionTypes = IGenericActionType<typeof eTongHopThongKeActionsObj, "TONG_HOP_THONG_KE">;